/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getCustomer = async (accessToken, params) => {
  try {
    return await clientService.getApi(`customers`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCustomerById = async (accessToken, id, params) => {
  try {
    const domain = `customers/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createCustomer = async (accessToken, body) => {
  try {
    const domain = `customers`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const exportCustomer = async (accessToken, params) => {
  const object = { ...params };
  Object.keys(object).forEach((key) => {
    if (object[key] === undefined || object[key] === null || object[key] === "") {
      delete object[key];
    }
  });
  try {
    const domain = `customers/export-excel`;
    return await clientService.exportExcel(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const updateCustomer = async (accessToken, customer_id, params) => {
  try {
    const domain = `customers/${customer_id}`;
    return await clientService.putApiFromData(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomer = async (accessToken, body) => {
  try {
    const domain = `customers`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCustomerRoutes = async (accessToken, customer_id, params) => {
  try {
    const domain = `customers/routes/${customer_id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createCustomerRoutes = async (accessToken, customer_id, body) => {
  try {
    const domain = `customers/routes/${customer_id}`;
    return await clientService.postApiRoute(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCustomerRoutes = async (accessToken, id, body) => {
  try {
    const domain = `customers/routes/${id}`;
    return await clientService.putApiRoute(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerRoutes = async (accessToken, id, body) => {
  try {
    const domain = `customers/routes/${id}`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyFormula = async (accessToken, customer_id, body) => {
  try {
    const domain = `customers/formula/${customer_id}`;
    return await clientService.getApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCustomerFormula = async (accessToken, customer_id, body) => {
  try {
    const domain = `customers/formula/${customer_id}`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteCustomerFormula = async (accessToken, id, body) => {
  try {
    const domain = `customers/formula/${id}`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCustomersList = async (accessToken, params) => {
  try {
    const domain = `customers/listcustomer`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCustomerByCompanyId = async (accessToken, id, params) => {
  try {
    const domain = `customers/company/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};
